<template>
  <div>
    <el-table
      :data="items"
      size="small"
      style="width: 100%"
      @expand-change="showChanges"
    >
      <el-table-column type="expand">
        <template #default="props">
          <vue-json-compare
            :old-data="prepareJson(props.row.attributes.object_changes, 0)"
            :new-data="prepareJson(props.row.attributes.object_changes, 1)"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="title"
        label="Item"
        align="center"
        :formatter="formatter"
      />
      <el-table-column align="center" label="Action" prop="action">
        <template #default="{ row }">
          <ActionLabel :action="row.attributes.event" />
        </template>
      </el-table-column>
      <el-table-column
        prop="created_at"
        label="Date"
        align="center"
        :formatter="formatter"
      />
    </el-table>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue'
import ActionLabel from './ActionLabel.vue'
import useResize from '@/hooks/useResize'
import formatter from '@/utils/table'
import vueJsonCompare from 'vue-json-compare'

export default defineComponent({
  name: 'HistoryTable',
  components: {
    ActionLabel,
    vueJsonCompare
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  setup(props, context) {
    const { isDesktop } = useResize()

    const prepareJson = (changes: any, index: number) => {
      const object = { ...changes }
      Object.keys(object).map((key: string) => {
        object[key] = object[key][index]
      })
      return object
    }

    const showChanges = (row: any) => {
      // context.emit('load', String(row.id))
    }

    return {
      isDesktop,
      formatter,
      showChanges,
      prepareJson
    }
  }
})
</script>

<style lang="scss" scoped></style>
